import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestMotoristas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'motoristas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteMotorista({ payload }) {
  try {
    const { idmotorista, params } = payload;

    yield call(api.delete, `motoristas/${idmotorista}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { motorista, params } = payload;

    yield call(api.post, 'motoristas', motorista);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/motoristas');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idmotorista } = payload;

    const { data } = yield call(api.get, `motoristas/${idmotorista}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { motorista, params } = payload;

    yield call(api.put, 'motoristas', motorista);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/motoristas');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'motoristas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@motorista/MOTORISTAS_IN_REQUEST', requestMotoristas),
  takeLatest('@motorista/DELETE_MOTORISTA', deleteMotorista),
  takeLatest('@motorista/SUCCESS_REMOVE', requestMotoristas),
  takeLatest('@motorista/STORE_MOTORISTA', store),
  takeLatest('@motorista/FIND_MOTORISTA', find),
  takeLatest('@motorista/UPDATE_MOTORISTA', update),
  takeLatest('@motorista/RECORD_FILTERING', applyedFilters),
]);
